<div class="relative h-[160px] w-[160px] bg-auto bg-center mx-auto">
	<a
		[href]="
			mainService.getOfferUrl(offer()) +
			'?' +
			mainService.getUrlParams(offer(), 'url', offersFacade.selected$ | async)
		"
		(click)="mainService.handleButtonClick($event, offer())"
	>
		@if (offer().multimedia?.length > 0 && !!offer().multimedia[0]?.multimedia.url) {
			@let imgWidth = 160;
			<img
				[ngSrc]="offer().multimedia[0]?.multimedia.url | optimizedImage: { width: imgWidth }"
				height="160"
				[width]="imgWidth"
				loading="lazy"
				[alt]="offer().product.name"
				class="rounded-[40px] h-full"
			/>
		} @else {
			<p>Brak zdjęcia</p>
		}
		<div
			class="absolute bg-white bg-opacity-70 bottom-0 left-0 w-full text-sm flex justify-center flex-col rounded-b-[40px] p-4 text-mainColor font-extrabold"
		>
			<h1 class="text-left w-9/10 md:whitespace-normal md:overflow-visible truncate">
				{{ offer().product.name }}
			</h1>
			<div class="flex flex-row justify-between w-9/10">
				<p class="text-xs md:text-base">od {{ offer().fullPrice | price }}</p>
			</div>
		</div>
	</a>
</div>
